<template>
  <v-container fluid grid-list-md style="background-color: rgb(244,244,244)">
    <v-layout column v-show="load">
      <v-flex>
        <VesselInfo v-bind:vesselData="displayedVesselInfo"/>
      </v-flex>
    </v-layout>
    <v-layout v-if="twinLayout" row v-show="load">
      <v-flex>
        <v-layout column>
          <v-flex>
            <FaultsTwinWidget v-bind:navigation="true" v-bind:engine="'Port'" :title="'Port Engine Faults'"/>
          </v-flex>

          <v-flex>
            <FaultsTwinWidget v-bind:navigation="true" v-bind:engine="'Stbd'" :title="'Stbd Engine Faults'"/>
          </v-flex>

          <v-flex>
            <PerformanceWidget v-bind:cardData="cardData['Port']" :title="'Port Engine Performance'" :engine="'Port'"/>
          </v-flex>

          <v-flex>
            <PerformanceWidget v-bind:cardData="cardData['Stbd']" :title="'Stbd Engine Performance'" :engine="'Stbd'"/>
          </v-flex>
        </v-layout>
      </v-flex>
    </v-layout>
    <v-layout v-else column v-show="load">
      <v-flex>
        <v-layout>
          <v-flex>
            <v-layout column>
              <v-flex>
                <EngineState v-bind:data="engineData"/>
              </v-flex>

              <v-flex>
                <SubsystemState v-bind:data="subSystemData"/>
              </v-flex>

              <v-flex>
                <PerformanceWidget v-bind:cardData="cardData" v-bind:gaugeData="gaugeData" :title="'Engine Performance'"/>
              </v-flex>

              <v-flex>
                <v-card fill-height style="height:100%;width:100%;">
                  <v-card-actions fill-height style="height:100%;padding-top:10px;">
                    <v-layout column fill-height>
                      <v-flex style="padding:0px;">
                        <Gauge v-bind:data="gaugeData['ensp']"/>
                      </v-flex>
                      <v-flex style="padding:0px;">
                        <Gauge v-bind:data="gaugeData['load']"/>
                      </v-flex>
                    </v-layout>
                  </v-card-actions>
                </v-card>
              </v-flex>

              <v-flex>
                <FaultsWidget v-bind:navigation="true"/>
              </v-flex>
            </v-layout>
          </v-flex>
        </v-layout>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>

import VesselInfo from '../controls/VesselInfo'
import EngineState from '../controls/EngineState'
import SubsystemState from '../controls/SubsystemState'
import PerformanceWidget from '../controls/PerformanceWidget'
import FaultsWidget from '../controls/FaultsWidget'
import Gauge from '../controls/Gauge'
import FaultsTwinWidget from '../controls/FaultsTwinWidget'

import {globalStore, vessels} from "../main.js"

export default {
  name: "VesselView",
  components: {
    VesselInfo,
    SubsystemState,
    EngineState,
    PerformanceWidget,
    FaultsWidget,
    FaultsTwinWidget,
    Gauge
  },
  data: function () {
    return {
      cardData: {},
      subSystemData: [],
      engineData: {
        cylinders: [],
        elements: [],
        engineKPI: 0,
        engineColor: 0
      },
      gaugeData: {},
      vesselData: {},
      vesselDataAllowed: ['timeStamp'],
      load: false
    }
  },
  created() {
  },
  mounted() {
    if (this.twinLayout)
      this.setTwinData();
    else
      this.setData();
  },
  methods: {
    average: function (param, count, data, timestamp) {
      let sum = 0;

      for (let i = 1; i <= count; i++) {
        if (data[timestamp][param + i] != -1000)
          sum += data[timestamp][param + i];
        else
          count--;
      }

      if ((sum == 0) || (count == 0))
        return -1000;
      else
        return sum / count;
    },
    setData() {
      var mapping = globalStore.mapping[globalStore.selectedIMO],
          units = globalStore.units[globalStore.selectedIMO],
          limits = globalStore.limits[globalStore.selectedIMO];

      if (typeof mapping == 'undefined') {
        mapping = globalStore.mapping[Object.keys(globalStore.mapping)[0]]
      }

      if (typeof units == 'undefined') {
        units = globalStore.units[Object.keys(globalStore.units)[0]]
      }

      if (typeof limits == 'undefined') {
        limits = globalStore.limits[Object.keys(globalStore.limits)[0]]
      }

      this.load = false;

      let refLength = Object.keys(globalStore.reference).length,
          sigLength = Object.keys(globalStore.signals).length;

      var temp;

      if (refLength > sigLength)
        temp = Object.keys(globalStore.signals);
      else
        temp = Object.keys(globalStore.reference);

      temp = temp.filter((item) => {
        return !isNaN(new Date(parseInt(item)).getTime());
      });

      let timestamp = temp[temp.length - 1];

      if (temp.indexOf('average') > -1)
        temp.splice(temp.indexOf('average'), 1);

      let last = temp[temp.length - 1];

      if (typeof last != 'undefined') {
        this.$set(this.vesselData, 'timeStamp', {
          label: 'Timestamp',
          value: new Date(parseInt(last)).toISOString().substring(0, 16).replace('T',' '),
          unit: '',
          format: null
        });
      }

      if (globalStore.type != 'last' && globalStore.type != 'today' && temp.length) {
        this.vesselData['timeStamp'].value = new Date(parseInt(temp[temp.length - 2])).toISOString().slice(0, 10);
      }

      let params = ['LAT', 'LON'];

      if (typeof globalStore.signals[last] != 'undefined') {
        for (let p = 0; p < params.length; p++) {
          this.$set(this.cardData, params[p], {
            label: mapping['mapping'][params[p]],
            value: globalStore.signals[last][params[p]],
            unit: '[' + units[params[p]] + ']',
            format: 2
          });
        }
      }

      params = ['ME_Torque_perc', 'ME_Power_perc', 'ensp', 'STW', 'SOG', 'Slip_STW', 'Slip_SOG', 'COG', 'Wind_Speed', 'Wind_direction_relative', 'Water_Depth', 'Rudder_angle'];

      if (typeof globalStore.signals[timestamp] != "undefined") {
        for (let p = 0; p < params.length; p++) {
          this.$set(this.vesselData, params[p], {
            label: mapping['mapping'][params[p]],//params[p],
            value: globalStore.signals[timestamp][params[p]],
            unit: '[' + units[params[p]] + ']',
            format: 2
          });
        }

        if (typeof globalStore.signals[timestamp]['load'] != 'undefined' && this.vesselData['ME_Power_perc'].value == -1000 && globalStore.signals[timestamp]['load'] != -1000)
          this.vesselData['ME_Power_perc'].value = globalStore.signals[timestamp]['load'] * 100;
      }

      this.$set(this.vesselData, 'route', []);
      let timeStamps = Object.keys(globalStore.signals);

      if (timeStamps.indexOf('average') > -1)
        timeStamps.splice(timeStamps.indexOf('average'), 1);

      params = ['ME_Power_perc', 'ensp', 'STW'];

      for (let i = 0; i < timeStamps.length; i++) {
        if (globalStore.signals[timeStamps[i]]['LON'] != -1000) {
          this.vesselData.route.push({'coords': [globalStore.signals[timeStamps[i]]['LON'], globalStore.signals[timeStamps[i]]['LAT']]});
        }
      }

      let kpi = 0;

      if (typeof globalStore.reference[timestamp] != 'undefined') {
        this.$set(this.engineData, 'engineColor', globalStore.reference[timestamp]['eng_KPI_color']);

        kpi = globalStore.reference[timestamp]['eng_KPI'] * 100;
      }

      if (kpi.toFixed(1) != '100.0')
        this.$set(this.engineData, 'engineKPI', kpi.toFixed(1));
      else
        this.$set(this.engineData, 'engineKPI', kpi.toFixed(0));

      this.engineData.cylinders = [];

      if (typeof globalStore.reference[timestamp] != 'undefined') {
        for (let c = 1; c <= this.cylCount; c++)
          this.engineData.cylinders.push(globalStore.reference[timestamp]['cyl' + c + '_KPI_color']);
      }

      let names = ['Turbines', 'Compressors', 'A/F', 'A/C'],
          tags = ['turb', 'comp', 'ac', 'af'];

      this.engineData.elements = [];

      for (let el = 0; el < names.length; el++) {
        let sum = 0;

        if (typeof globalStore.reference[timestamp] != 'undefined') {
          for (let t = 1; t <= this.tcCount; t++) {
            sum += globalStore.reference[timestamp][tags[el] + t + '_KPI_color'];
          }

          this.engineData.elements.push({
            name: names[el],
            color: sum / this.tcCount
          });
        }
      }

      this.subSystemData = [];
      names = ['Servo Oil', 'Fuel Injection', 'Exhaust Gas', 'Scavenge Air', 'Piston Running', 'Automation & Control'];
      tags = ['so_KPI_color', 'fi_KPI_color', 'egs_KPI_color', 'sac_KPI_color', 'pr_KPI_color', 'ca_KPI_color'];

      if (globalStore.gasEngine) {
        names.splice(5, 0, 'Gas Admission');
        tags.splice(5, 0, 'gas_KPI_color');
      }

      if (typeof globalStore.signals[timestamp] != "undefined") {
        for (let sys = 0; sys < names.length; sys++) {
          this.subSystemData.push({
            system: names[sys],
            value: globalStore.reference[timestamp][tags[sys]]
          });
        }
      }

      let customTicks = [];
      for (let i = 10; i <= 110; i += 10) {
        customTicks.push(i);
      }

      //gauges
      if (typeof globalStore.signals[timestamp] != "undefined") {
        this.$set(this.gaugeData, 'load', {
          value: globalStore.signals[timestamp]['ME_Power_perc'],
          rangeLimit: 100,
          startValue: 10,
          endValue: 110,
          customTicks: customTicks,
          format: 1,
          unit: '[' + units['ME_Power_perc'] + ']',
          title: mapping['mapping']['ME_Power_perc']
        });

        if (this.gaugeData['load'].value == -1000 && globalStore.signals[timestamp]['load'] != -1000)
          this.gaugeData['load'].value = globalStore.signals[timestamp]['load'] * 100;

        if ((this.gaugeData['load'].value == -1000) && (globalStore.signals[timestamp]['load'] != -1000))
          this.gaugeData['load'].value = globalStore.signals[timestamp]['load'] * 100;
      }

      let rpmMcr = Math.round(globalStore.loadDiagram['otVal2']),
          intNum = 10,
          lowSpeed = rpmMcr / 2,
          step = Math.ceil(lowSpeed / (intNum - 2));

      customTicks = [];

      let tick = rpmMcr - (intNum - 1) * step;

      customTicks.push(tick);

      for (let i = 0; i < intNum; i++) {
        tick += step;
        customTicks.push(tick);
        for (let i = 0; i <= intNum; i++) {
          tick += step;
          customTicks.push(tick);
        }

        if (typeof globalStore.signals[timestamp] != "undefined") {
          this.$set(this.gaugeData, 'ensp', {
            value: globalStore.signals[timestamp]['ensp'],
            rangeLimit: rpmMcr,
            startValue: customTicks[0],
            endValue: customTicks[intNum],
            tickInterval: step,
            customTicks: customTicks,
            format: 1,
            unit: '[rpm]',
            title: 'Engine Speed'
          });
          this.$set(this.gaugeData, 'bsfc', {
            value: globalStore.signals[timestamp]['bsfc'],
            rangeLimit: 190,
            startValue: 150,
            endValue: 210,
            tickInterval: 10,
            format: 1,
            unit: '[g/kWh]',
            title: 'SFOC'
          });
        }

        //performance Data
        params = ['pcomp', 'pmax', 'tcspeed', 'tTurbIn', 'pscav', 'bsfc'];
        let refs = ['pcomp', 'pmax', 'tcspeed', 'tTurbIn', 'pscav', 'bsfc'],
            elCount = [this.cylCount, this.cylCount, this.tcCount, this.tcCount, 0, 0];

        for (let p = 0; p < params.length; p++) {
          let val, rfr;

          if (typeof globalStore.signals[timestamp] != "undefined") {
            if (elCount[p] > 0)
              val = this.average(params[p], elCount[p], globalStore.signals, timestamp);
            else
              val = globalStore.signals[timestamp][params[p]];

            if (elCount[p] > 0)
              rfr = this.average(refs[p], elCount[p], globalStore.reference, timestamp);
            else
              rfr = globalStore.reference[timestamp][refs[p]];
          } else {
            val = -1000;
            rfr = -1000;
          }

          if (isNaN(val))
            val = -1000;

          if (isNaN(rfr))
            rfr = -1000;

          let color = -10;

          if (val != -1000 && rfr != -1000 && Object.keys(limits).includes(params[p])) {
            let minLimit = limits[params[p]][0], maxLimit = limits[params[p]][1];

            let temp = ((val - rfr) / val) * 100;

            if (temp > minLimit && temp < maxLimit)
              color = 0;
            else
              color = 20;
          }

          this.$set(this.cardData, params[p], {
            value: val,
            ref: rfr,
            title: mapping['mapping'][params[p]],
            unit: units[params[p]],
            format: 2,
            color: color
          });
        }

        this.load = true;
      }
    },
    setTwinData() {
      var units = globalStore.units[globalStore.selectedIMO],
          limits = globalStore.limits[globalStore.selectedIMO];

      if (typeof units == 'undefined') {
        units = globalStore.units[Object.keys(globalStore.units)[0]]
      }

      if (typeof limits == 'undefined') {
        limits = globalStore.limits[Object.keys(globalStore.limits)[0]]
      }

      this.load = false;

      if (typeof globalStore.twinSignals != 'undefined' && typeof globalStore.twinReference != 'undefined' && typeof globalStore.twinSignals['Port'] != 'undefined' && typeof globalStore.twinReference['Port'] != 'undefined') {
        var mapping = globalStore.mapping[globalStore.selectedIMO];

        if (typeof mapping == 'undefined') {
          mapping = globalStore.mapping[Object.keys(globalStore.mapping)[0]]
        }

        let temp = Object.keys(globalStore.twinSignals['Port']).filter(value => -1 !== Object.keys(globalStore.twinReference['Port']).indexOf(value)),
            refLength = Object.keys(globalStore.twinReference['Port']).length,
            sigLength = Object.keys(globalStore.twinSignals['Port']).length,
            timestamp = ((refLength > sigLength) ? globalStore.twinSignals['Port']['lastDate'] : globalStore.twinSignals['Port']['lastDate']);

        if (temp.indexOf('average') > -1)
          temp.splice(temp.indexOf('average'), 1);

        let last = timestamp;

        this.$set(this.vesselData, 'timeStamp', {
          label: 'Timestamp',
          value: new Date(parseInt(last)).toISOString().substring(0, 16).replace('T',' '),
          unit: '',
          format: null
        });

        if (globalStore.type != 'last' && globalStore.type != 'today') {
          this.vesselData['timeStamp'].value = new Date(last).toISOString().slice(0, 10);
        }

        let params = ['LAT', 'LON'];

        for (let p = 0; p < params.length; p++) {
          this.$set(this.cardData, params[p], {
            label: mapping['mapping'][params[p]],
            value: ((typeof globalStore.twinSignals['Port'][last] != 'undefined') ? globalStore.twinSignals['Port'][last][params[p]] : -1000),
            unit: '[' + units[params[p]] + ']',
            format: 2
          });
        }

        params = ['ME_Torque_perc', 'ME_Power_perc', 'ensp'];

        for (let p = 0; p < params.length; p++) {
          let vP = ((typeof globalStore.twinSignals['Port'][timestamp] != 'undefined') ? globalStore.twinSignals['Port'][timestamp][params[p]].toFixed(2) : -1000),
              vS = ((typeof globalStore.twinSignals['Stbd'][timestamp] != 'undefined') ? globalStore.twinSignals['Stbd'][timestamp][params[p]].toFixed(2) : -1000);

          if (isNaN(vP) || vP == -1000)
            vP = '-';
          if (isNaN(vS) || vS == -1000)
            vS = '-';

          this.$set(this.vesselData, params[p], {
            label: mapping['mapping'][params[p]],
            valuePort: vP,
            valueStbd: vS,
            unit: '[' + units[params[p]] + ']',
            format: 2
          });
        }

        params = ['STW', 'SOG', 'Slip_STW', 'Slip_SOG', 'COG', 'Wind_Speed', 'Wind_direction_relative', 'Water_Depth', 'Rudder_angle'];

        for (let p = 0; p < params.length; p++) {
          this.$set(this.vesselData, params[p], {
            label: mapping['mapping'][params[p]],
            value: ((typeof globalStore.twinSignals['Port'][timestamp] != 'undefined') ? globalStore.twinSignals['Port'][timestamp][params[p]] : -1000),
            unit: '[' + units[params[p]] + ']',
            format: 2
          });
        }

        //performance Data
        params = ['pcomp', 'pmax', 'tcspeed', 'tTurbIn', 'pscav', 'bsfc'];

        let engines = ['Port', 'Stbd'],
            refs = ['pcomp', 'pmax', 'tcspeed', 'tTurbIn', 'pscav', 'bsfc'],
            elCount = [this.cylCount, this.cylCount, this.tcCount, this.tcCount, 0, 0];

        engines.forEach(eng => {
          this.cardData[eng] = {};

          temp = Object.keys(globalStore.twinSignals[eng]).filter(value => -1 !== Object.keys(globalStore.twinReference[eng]).indexOf(value));
          timestamp = ((refLength > sigLength) ? globalStore.twinSignals['Port']['lastDate'] : globalStore.twinSignals['Port']['lastDate']);

          for (let p = 0; p < params.length; p++) {
            let val, rfr;

            if (typeof globalStore.twinSignals[eng][timestamp] != "undefined") {
              if (elCount[p] > 0)
                val = this.average(params[p], elCount[p], globalStore.twinSignals[eng], timestamp);
              else
                val = globalStore.twinSignals[eng][timestamp][params[p]];

              if (elCount[p] > 0)
                rfr = this.average(refs[p], elCount[p], globalStore.twinReference[eng], timestamp);
              else
                rfr = globalStore.twinReference[eng][timestamp][refs[p]];
            } else {
              val = -1000;
              rfr = -1000;
            }

            if (isNaN(val))
              val = -1000;

            if (isNaN(rfr))
              rfr = -1000;

            let color = -10;

            if (val != -1000 && rfr != -1000 && Object.keys(limits).includes(params[p])) {
              let minLimit = limits[params[p]][0],
                  maxLimit = limits[params[p]][1],
                  temp = ((val - rfr) / val) * 100;

              if (temp > minLimit && temp < maxLimit)
                color = 0;
              else
                color = 20;
            }

            this.$set(this.cardData[eng], params[p], {
              value: val,
              ref: rfr,
              title: mapping['mapping'][params[p]],
              unit: units[params[p]],
              format: 2,
              color: color
            });
          }

        });

        globalStore.loading = false;
      }

      this.load = true;
    },
  },
  computed: {
    dataLoaded: function () {
      return globalStore.type;
    },
    selVessel: function () {
      return globalStore.selectedVessel;
    },
    cylCount: function () {
      return globalStore.cylCount;
    },
    tcCount: function () {
      return globalStore.tcCount;
    },
    twinLayout: function () {
      return globalStore.twinEngine;
    },
    displayedVesselInfo: function () {
      var vesselDataDisplay = {};

      for (var i in this.vesselDataAllowed) {
        if (this.vesselDataAllowed.hasOwnProperty(i)) {
          vesselDataDisplay[this.vesselDataAllowed[i]] = this.vesselData[this.vesselDataAllowed[i]];
        }
      }

      return vesselDataDisplay;
    }
  },
  watch: {
    dataLoaded: function () {
      if (this.dataLoaded != '') {
        if (this.twinLayout)
          this.setTwinData();
        else
          this.setData();
      }
    },
    selVessel: function () {
      if (this.dataLoaded != '') {
        if (this.twinLayout)
          this.setTwinData();
        else
          this.setData();
      }
    }
  }
}
</script>

<style scoped>

</style>
